<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Alert Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickClose"
                >
                    Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px;"
            v-if="profile != null"
        >

            <m-named-pair
                text="Alert Type"
                :value="alert.alert_type"
            />


            <m-named-pair
                text="Alert Id"
                :value="alert.alert_id"
            />

            <m-named-pair
                text="Time"
                :value="$rc.pretty(alert.time,'date_and_time')"
            />

            <m-named-pair
                text="Text Content"
                :value="alert.text_content"
            />

            <m-named-pair
                text="Email Subject"
                :value="alert.email_subject"
            />

            <m-named-pair
                text="Email Body"
                :value="alert.email_body"
            />

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
            
                <template v-slot:item.endpoint="{ item }">
                    {{prettyEndpoint(item)}}
                </template>

            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            profile: null,
            alert: null,
            results: [],
            headers: [
                { text: 'To', value: 'recipient_label'},
                { text: 'Method', value: 'delivery_method'},
                { text: 'Endpoint', value: 'endpoint'},
                { text: 'Status', value: 'delivery_status'},
            ],
        }
    },

    methods: {

        showDialog(alert_id)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/alert/profile/:alert_id',
            
                'params' : {
                        'alert_id': alert_id,
                    },
            
                'on_success': (data) => {
                        this.dialog = true;
                        this.alert = data.alert;
                        this.results = data.delivery_records;
                        this.profile = data;
                        this.last_dialog_guard = this.$router.dialog_guard;
                        this.$router.dialog_guard = this.dialogGuard;
                    },
            
                'on_error': 'Unable to get alert details',
            });
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickClose()
        {
            this.closeDialog();
        },

        prettyEndpoint(item)
        {
            if ( item.to_endpoint != null )
            {
                return this.$rc.pretty(item.to_endpoint,'endpoint_no_parens');
            }

            if ( item.to_email != null )
            {
                return item.to_email;
            }

            return null;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>